<template>
  <div>
    <!-- <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addOrder">{{ $t('addOrder') }}</button>
      </div>
    </div> -->
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="caption" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
    <!-- Pop ups -->
    <OrderPopUp :order="selectedOrder" @closeConfirmRequested="selectedOrder = null" v-model="selectedOrder"></OrderPopUp>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/views/controls/PaginatedTable.vue'
import OrderPopUp from "@/views/controls/popups/OrderPopUp.vue";
import SearchBar from '@/views/controls/SearchBar.vue'
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { formatDate, convertToCamelCase, convertToPascalCase } from "@/helpers/utils.js";

export default {
  components: { CTableWrapper, SearchBar, OrderPopUp },
  data () {
    return {
      selectedOrder: null,
      selectedOrderStatus: null,
      searchText: '',
      caption: i18n.t('orders'),
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'id', label: i18n.t('id'), _classes: 'font-weight-bold', sortable: true },
        { key: 'createdAt', label: i18n.t('createdAt'), sortable: true },
        { key: 'status', label: i18n.t('status'), sortable: true },
        { key: 'userEmail', label: i18n.t('user'), sortable: true },
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'markPaid', label: i18n.t('markPaid') },
        { key: 'delete', label: i18n.t('delete') }
      ],
      sorterValue: { column: 'id', asc: false },
      loading: false,
    }
  },
  computed: {
    ...mapState('orders', ['listOutput']),
    ...mapState('orders', ['processTask']),
    ordersInfo: function() {
      return this.listOutput && this.listOutput.data ? this.listOutput.data : null;
    },
    items: function()
    {
      var result = [];

      if(this.ordersInfo)
      {
        result = this.ordersInfo;

        result.forEach(order => {
          order["createdAt"] = formatDate(order.createdAt);
          order["userEmail"] = order.userEmail ? order.userEmail : '';
          order["status"] = this.$i18n.t(convertToCamelCase(order.status));
        });
      }

      return result;
    },
    pages: function()
    {
      return this.listOutput ? this.listOutput.totalPages : 1;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('orders', ['getList']),
    ...mapActions('orders', ['remove']),
    ...mapActions('orders', ['markPaid']),
    rowClicked (item, index) {
      this.selectedOrder = item;
      // this.$router.push({name: "EditOrder", params: { order: item } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.selectedOrder = item;
          // this.$router.push({name: "EditOrder", params: { order: item } });
          break;
        }
        case 'markPaid':
        {
          if(confirm(this.$i18n.tc('confirmMarkPaid', item.id, { id: item.id }))){
            this.markPaid(item.id);
          }
          break;
        }
        case 'delete':
        {
          if(confirm(this.$i18n.tc('confirmRemove', item.id, { name: item.id }))){
            this.remove(item.id);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    statusChangeRequested()
    {
      // Make request
      this.selectedOrderStatus = null;
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

       var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
      this.getList(input); 
    },
    addOrder () 
    {
      alert("This will be ready soon");
      // router.push({ path: '/orders/add' });
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }    
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    processTask: function(val)
    {
      this.loading = true;

      // order was deleted or the status was changed, reload list
      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    listOutput: function(val)
    {
      this.loading = false;
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 